import { Controller } from "stimulus"


export default class extends Controller {
  static targets = ["form","drawer", "body", "status", "tab", "panel2", "title", "saveButton",
    "imagePickerButton", "imagePreview", "cropDetails",
    "videoInput", "videoPreview", "removeVideoToggle",
    "modifierHome", "modifierSearchPanel", "modifierGroupForm", "modifierTypeChooser", "newOptionItems",
    "modifierProductSearchInput", "modifierProductSuggestions", "assignedModifierGroupsList",
    "existingModifierSearchInput", "existingModifierSuggestions",
    "drawerTabs", "newItemChoiceScreen", "templateSelectorScreen", "templateList",
    "existingItemSelectorScreen", "existingItemSearch", "existingItemList", "existingItemEmpty",
    "stockItemSearchInput", "stockItemSuggestions", "stockItemRows", "stockItemCount"
  ]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    document.addEventListener("click", this.handleDocumentClick)
    this.activeTrigger = null
    this.defaultDrawerTitle = this.hasTitleTarget ? this.titleTarget.textContent.trim() : ""
    this.defaultImagePickerLabel = this.hasImagePickerButtonTarget
      ? (this.imagePickerButtonTarget.dataset.defaultLabel || this.imagePickerButtonTarget.textContent.trim() || "Pick Image")
      : "Pick Image"
    this.persistedImageUrl = ""
    this.persistedVideoUrl = ""
    this.cachedTemplates = this.parseMenuItemTemplates()
    this.optionCatalog = this.parseOptionCatalog()
    this.resetLocalModifierState()
    this.resetStockItemsState()
    this.resetImageState()
    this.resetVideoState()
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.removeEventListener("click", this.handleDocumentClick)
    this.unlockBody()
  }

  handleDocumentClick(event) {
    this.closeSuggestionsOnOutsideClick(
      event,
      this.hasModifierProductSuggestionsTarget ? this.modifierProductSuggestionsTarget : null
    )
    this.closeSuggestionsOnOutsideClick(
      event,
      this.hasExistingModifierSuggestionsTarget ? this.existingModifierSuggestionsTarget : null
    )
    this.closeSuggestionsOnOutsideClick(
      event,
      this.hasStockItemSuggestionsTarget ? this.stockItemSuggestionsTarget : null
    )
  }

  closeSuggestionsOnOutsideClick(event, suggestionsTarget) {
    if (!suggestionsTarget || suggestionsTarget.hidden) return

    const searchBar = suggestionsTarget.closest(".menu-v2-modifier-group-search-bar")
    if (searchBar && !searchBar.contains(event.target)) {
      suggestionsTarget.hidden = true
    }
  }

  open2(event){
    document.body.classList.add("menu-v2-drawer-open")

    event.preventDefault()
    this.activeTrigger = event.currentTarget
    this.formSnapshot = undefined
    this.resetLocalModifierState()
    this.resetStockItemsState()
    // Items built from several stock items edit them on the Stock Items tab
    // instead of the single-item fields; the real list arrives with editor_data.
    this.setStockItemsMode(Number(event.currentTarget.dataset.menuItemStockItemCount || 0) > 1)
    this.setActiveTab("1")
    const id = event.currentTarget.dataset.menuItemId

    const restaurantId = event.currentTarget.dataset.restaurantId

    const categoryId = event.currentTarget.dataset.categoryId

    // The instance (placement) id is what the POS appearance is attached to; it is
    // needed both to prefill the Menu Appearance field and to save it. Empty for
    // new items - the instance is created on save.
    const instanceField = this.formTarget.querySelector('[name="menu_item_instance_id"]')
    if (instanceField) instanceField.value = event.currentTarget.dataset.menuItemInstanceId || ""

    // this.formTarget.action = `/restaurants/${restaurantId}/v2/menu_items/${id}`

    // Determine form action
    if (categoryId) {
      this.setDrawerTitle("Create Product")

      // New item → POST to create URL
      this.formTarget.action = `/restaurants/${restaurantId}/v2/menu_items`
      this.formTarget.method = "POST" // optional if you have Rails UJS

      // --- DETAILS ---
      this.formTarget.querySelector('[name="[details][name]"]').value = ""
      this.formTarget.querySelector('[name="[details][description]"]').value =  ""
      this.formTarget.querySelector('[name="[details][price]"]').value = ""
      this.formTarget.querySelector('input[type="checkbox"][name="[details][disabled]"]').checked = false
      this.formTarget.querySelector('input[type="checkbox"][name="[details][stock_control_enabled]"]').checked = false
    
      this.resetImageState()
    
      // --- RELATIONSHIPS MULTI-SELECTS ---
      const setMultiSelect = (selector, ids = []) => {
        const select = this.formTarget.querySelector(selector)
        if (!select) return
        Array.from(select.options).forEach(opt => opt.selected = false)
        ids.forEach(id => {
          const option = select.querySelector(`option[value="${id}"]`)
          if (option) option.selected = true
        })
        if ($(select).hasClass('select2-hidden-accessible')) $(select).trigger('change')
      }
    
      setMultiSelect('select[name="relationships[dietary_requirement_ids][]"]', [])
      setMultiSelect('select[name="relationships[ingredient_ids][]"]', [])
      setMultiSelect('select[name="relationships[allergen_ids][]"]', [])
      setMultiSelect('select[name="relationships[possible_allergen_ids][]"]', [])

      // --- ADVANCED FIELDS ---
      this.formTarget.querySelector('[name="[advanced][internal_name]"]').value = ""
      this.formTarget.querySelector('[name="[advanced][reporting_category]"]').value = ""
      this.formTarget.querySelector('[name="[advanced][primary_screen]"]').value = ""
      this.formTarget.querySelector('[name="[advanced][secondary_screen]"]').value = ""
      this.formTarget.querySelector('[name="[advanced][modal_override]"]').value = ""
      this.formTarget.querySelector('[name="[advanced][delivery_tax_rate]"]').value = 0
      this.formTarget.querySelector('[name="[advanced][takeaway_tax_rate]"]').value = 0
      this.formTarget.querySelector('[name="[advanced][eat_in_tax_rate]"]').value = 0
      this.formTarget.querySelector('[name="[advanced][cost_price]"]').value = 0

      const newThresholdField = this.formTarget.querySelector('[name="[advanced][stock_warning_threshold]"]')
      if (newThresholdField) newThresholdField.value = ""

      this.applyDefaultSettings()


      this.formTarget.querySelector('[name="category_id"]').value = categoryId || 0

      this.clearCurrentModifiers()
      this.captureFormSnapshot()
      this.showNewItemChoiceScreen()

    } else {
      this.resetDrawerTitle()
      this.resetImageState()

      // Existing item → PATCH to update URL
      this.formTarget.action = `/restaurants/${restaurantId}/v2/menu_items/${id}`

      this.formTarget.method = "PUT" 

    }

    this.drawerTarget.classList.add("is-open")
    this.drawerTarget.setAttribute("aria-hidden", "false")

    this.refreshDrawerPickerSources(restaurantId)

    // i have the id now i need to fetch the data from controller
    if (!categoryId) {
      this.loadMenuItem(id, restaurantId)
      this.loadCurrentModifiers(id, restaurantId)
    }
  }

  async refreshDrawerPickerSources(restaurantId) {
    const menuId = this.getMenuId()
    if (!restaurantId || !menuId) return

    try {
      const response = await fetch(
        `/restaurants/${restaurantId}/v2/menus/${menuId}/drawer_picker_sources`,
        { headers: { "Accept": "application/json" } },
      )
      if (!response.ok) return

      const fresh = await response.json()
      this.optionCatalog = { ...this.optionCatalog, ...fresh }
    } catch (_error) {
      // Keep the previously-parsed sources if the refresh fails.
    }
  }

  async loadMenuItem(id, restaurantId) {
    try {
      // Pass the instance id so the server can resolve this placement's saved
      // Menu Appearance (menu_appearance_id) for prefilling the Advanced tab.
      const instanceField = this.formTarget.querySelector('[name="menu_item_instance_id"]')
      const instanceId = instanceField && instanceField.value
      const editorDataUrl = instanceId
        ? `/restaurants/${restaurantId}/v2/menu_items/${id}/editor_data?menu_item_instance_id=${instanceId}`
        : `/restaurants/${restaurantId}/v2/menu_items/${id}/editor_data`

      const response = await fetch(
        editorDataUrl,
        {
          headers: { "Accept": "application/json" }
        }
      )
  
      if (!response.ok) throw new Error("Request failed")
  
      const data = await response.json()

      this.applyStockItems(data.stock_items)
      this.fillForm(data.details, data.relationships, data.advanced)
    } catch (error) {
      console.error(error)
    }
  }

  loadCurrentModifiers(id, restaurantId, targetId = "menu-v2-current-modifiers") {
    $.ajax({
      url: `/restaurants/${restaurantId}/v2/menu_items/${id}/current_modifiers`,
      method: "GET",
      dataType: "script",
      data: { target_id: targetId },
    }).fail((error) => {
      console.error(error)
    })
  }

  async toggleAvailability(event) {
    const input = event.currentTarget
    const { menuItemId, url } = input.dataset

    if (!menuItemId || !url) return

    const nextAvailable = input.checked
    this.setAvailabilityLoadingState(menuItemId, true)

    try {
      const response = await fetch(url, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken(),
        },
        body: JSON.stringify({ disabled: !nextAvailable, menu_id: this.getMenuId() }),
      })

      const data = await response.json().catch(() => ({}))

      if (!response.ok) {
        throw new Error(data.error || "Failed to update availability")
      }

      this.syncAvailabilityState(menuItemId, {
        available: !!data.available,
        disabled: !!data.disabled,
      })
      this.notifyMenuChanged()
    } catch (error) {
      console.error(error)
      this.syncAvailabilityState(menuItemId, {
        available: !nextAvailable,
        disabled: nextAvailable,
      })
      this.setStatus("Unable to update availability right now.", "error")
    } finally {
      this.setAvailabilityLoadingState(menuItemId, false)
    }
  }

  async toggleFeatured(event) {
    event.preventDefault()

    const button = event.currentTarget
    const { menuItemId, url } = button.dataset

    if (!menuItemId || !url) return

    const nextFeatured = button.dataset.featured !== "true"
    this.setFeaturedLoadingState(menuItemId, true)

    try {
      const response = await fetch(url, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken(),
        },
        body: JSON.stringify({ featured: nextFeatured, menu_id: this.getMenuId() }),
      })

      const data = await response.json().catch(() => ({}))

      if (!response.ok) {
        throw new Error(data.error || "Failed to update featured state")
      }

      this.syncFeaturedState(menuItemId, !!data.featured)
      this.resetStatus()
      this.notifyMenuChanged()
    } catch (error) {
      console.error(error)
      this.setStatus("Unable to update featured status right now.", "error")
    } finally {
      this.setFeaturedLoadingState(menuItemId, false)
    }
  }

  fillForm(details = {}, relationships = {}, advanced = {}) {
    // --- DETAILS ---
    this.formTarget.querySelector('[name="[details][name]"]').value = details.name || ""
    this.formTarget.querySelector('[name="[details][description]"]').value = details.description || ""
    this.formTarget.querySelector('[name="[details][price]"]').value = details.price || ""
    this.formTarget.querySelector('input[type="checkbox"][name="[details][disabled]"]').checked = !!details.disabled
    this.formTarget.querySelector('input[type="checkbox"][name="[details][stock_control_enabled]"]').checked = !!details.stock_control_enabled
  
    this.resetImageState(details.image_url || "")
    this.resetVideoState(details.video_url || "")

    // --- RELATIONSHIPS MULTI-SELECTS ---
    const setMultiSelect = (selector, ids = []) => {
      const select = this.formTarget.querySelector(selector)
      if (!select) return
      Array.from(select.options).forEach(opt => opt.selected = false)
      ids.forEach(id => {
        const option = select.querySelector(`option[value="${id}"]`)
        if (option) option.selected = true
      })

      if ($(select).hasClass('select2-hidden-accessible')) $(select).trigger('change')
    }
  
    setMultiSelect('select[name="relationships[dietary_requirement_ids][]"]', relationships.dietary_requirement_ids)
    setMultiSelect('select[name="relationships[ingredient_ids][]"]', relationships.ingredient_ids)
    setMultiSelect('select[name="relationships[allergen_ids][]"]', relationships.allergen_ids)
    setMultiSelect('select[name="relationships[possible_allergen_ids][]"]', relationships.possible_allergen_ids)

    this.formTarget.querySelector('[name="[advanced][internal_name]"]').value = advanced.internal_name || ""
    this.formTarget.querySelector('[name="[advanced][reporting_category]"]').value = advanced.reporting_category || ""
    this.formTarget.querySelector('[name="[advanced][primary_screen]"]').value = advanced.primary_screen || ""
    this.formTarget.querySelector('[name="[advanced][secondary_screen]"]').value = advanced.secondary_screen || ""
    this.formTarget.querySelector('[name="[advanced][modal_override]"]').value = advanced.modal_override || ""

    // Menu Appearance is a select2-enhanced field (appearance-swatch controller),
    // so setting .value alone won't update the rendered selection - trigger change.
    const appearanceSelect = this.formTarget.querySelector('[name="[advanced][menu_appearance_id]"]')
    if (appearanceSelect) {
      const appearanceValue = advanced.menu_appearance_id ? String(advanced.menu_appearance_id) : ""
      appearanceSelect.value = appearanceValue
      if ($(appearanceSelect).hasClass('select2-hidden-accessible')) $(appearanceSelect).val(appearanceValue).trigger('change')
    }

    this.formTarget.querySelector('[name="[advanced][delivery_tax_rate]"]').value = advanced.delivery_tax_rate || 0
    this.formTarget.querySelector('[name="[advanced][takeaway_tax_rate]"]').value = advanced.takeaway_tax_rate || 0
    this.formTarget.querySelector('[name="[advanced][eat_in_tax_rate]"]').value = advanced.eat_in_tax_rate || 0
    this.formTarget.querySelector('[name="[advanced][cost_price]"]').value = advanced.cost_price || 0

    const thresholdField = this.formTarget.querySelector('[name="[advanced][stock_warning_threshold]"]')
    if (thresholdField) {
      thresholdField.value = advanced.stock_warning_threshold ?? ""
    }

    this.captureFormSnapshot()
  }

  availabilityToggles(menuItemId) {
    return Array.from(this.element.querySelectorAll(".menu-v2-availability-toggle")).filter((toggle) => (
      String(toggle.dataset.menuItemId) === String(menuItemId)
    ))
  }

  menuItemEditTriggers(menuItemId) {
    return Array.from(this.element.querySelectorAll("[data-menu-item-disabled]")).filter((trigger) => (
      String(trigger.dataset.menuItemId) === String(menuItemId)
    ))
  }

  menuItemEditTrigger(menuItemId, restaurantId = null) {
    return Array.from(this.element.querySelectorAll('[data-action="click->menu-item-drawer#open2"]')).find((trigger) => (
      String(trigger.dataset.menuItemId) === String(menuItemId) &&
      (restaurantId === null || String(trigger.dataset.restaurantId) === String(restaurantId))
    )) || null
  }

  setAvailabilityLoadingState(menuItemId, loading) {
    this.availabilityToggles(menuItemId).forEach((toggle) => {
      toggle.disabled = loading
    })
  }

  featuredButtons(menuItemId) {
    return Array.from(this.element.querySelectorAll(".menu-v2-featured-toggle")).filter((button) => (
      String(button.dataset.menuItemId) === String(menuItemId)
    ))
  }

  setFeaturedLoadingState(menuItemId, loading) {
    this.featuredButtons(menuItemId).forEach((button) => {
      button.disabled = loading
    })
  }

  syncFeaturedState(menuItemId, featured) {
    this.featuredButtons(menuItemId).forEach((button) => {
      button.dataset.featured = String(featured)
      button.classList.toggle("is-active", featured)
      button.setAttribute("aria-pressed", String(featured))

      const itemName = button.dataset.menuItemName || "item"
      button.setAttribute("aria-label", `${featured ? "Unfeature" : "Feature"} ${itemName}`)

      const icon = button.querySelector("i")
      if (!icon) return

      icon.classList.toggle("fa-solid", featured)
      icon.classList.toggle("fa-regular", !featured)
    })
  }

  syncAvailabilityState(menuItemId, { available, disabled }) {
    this.availabilityToggles(menuItemId).forEach((toggle) => {
      toggle.checked = available
    })

    this.menuItemEditTriggers(menuItemId).forEach((trigger) => {
      trigger.dataset.menuItemDisabled = String(disabled)
    })

    if (this.activeTrigger && String(this.activeTrigger.dataset.menuItemId) === String(menuItemId)) {
      this.activeTrigger.dataset.menuItemDisabled = String(disabled)
    }

    const disabledInput = this.formTarget.querySelector('[name="[details][disabled]"]')
    if (disabledInput && String(this.activeTrigger?.dataset.menuItemId) === String(menuItemId)) {
      disabledInput.checked = disabled
    }
  }

  syncSavedMenuItem(menuItem = {}) {
    if (!menuItem || !menuItem.id) return

    const restaurantId = this.activeTrigger?.dataset.restaurantId || this.restaurantIdFromUrl(this.formTarget.action)
    const refreshedTrigger = this.menuItemEditTrigger(menuItem.id, restaurantId)

    if (refreshedTrigger) {
      this.activeTrigger = refreshedTrigger
    } else if (this.activeTrigger) {
      this.activeTrigger.dataset.menuItemId = String(menuItem.id)
    }

    if (menuItem.image_url !== undefined) {
      this.resetImageState(menuItem.image_url || "")
    }

    if (menuItem.video_url !== undefined) {
      this.resetVideoState(menuItem.video_url || "")
    }
  }

  close(event) {
    if (event) event.preventDefault()

    if (!this.hasDrawerTarget || !this.drawerTarget.classList.contains("is-open")) return

    if (this.hasUnsavedChanges()) {
      const confirmed = window.confirm(
        "You have unsaved changes. Are you sure you want to close? Your changes will be lost."
      )
      if (!confirmed) return
    }

    this.resetDrawerTitle()
    this.drawerTarget.classList.remove("is-open")
    this.drawerTarget.setAttribute("aria-hidden", "true")

    if (this.activeTrigger) {
      this.activeTrigger.setAttribute("aria-expanded", "false")
    }

    document.removeEventListener("keydown", this.handleKeydown)
    this.unlockBody()
    this.resetStatus()

    if (this.activeTrigger) {
      this.activeTrigger.focus()
    }
  }

  // --- Unsaved-changes guard ---
  // Serialize every user-editable part of the drawer (Details, Allergens &
  // Ingredients relationships, Advanced, and the image) into a comparable
  // string so we can detect edits the user made but never saved.
  serializeFormState() {
    if (!this.hasFormTarget) return ""

    const form = this.formTarget
    const value = (selector) => {
      const el = form.querySelector(selector)
      return el ? el.value : ""
    }
    const checked = (selector) => {
      const el = form.querySelector(selector)
      return el ? el.checked : false
    }
    const multiSelect = (name) => {
      const select = form.querySelector(`select[name="${name}"]`)
      if (!select) return ""
      return Array.from(select.selectedOptions).map((option) => option.value).sort().join(",")
    }

    return JSON.stringify({
      name: value('[name="[details][name]"]'),
      description: value('[name="[details][description]"]'),
      price: value('[name="[details][price]"]'),
      disabled: checked('input[type="checkbox"][name="[details][disabled]"]'),
      stock_control_enabled: checked('input[type="checkbox"][name="[details][stock_control_enabled]"]'),
      dietary_requirement_ids: multiSelect("relationships[dietary_requirement_ids][]"),
      ingredient_ids: multiSelect("relationships[ingredient_ids][]"),
      allergen_ids: multiSelect("relationships[allergen_ids][]"),
      possible_allergen_ids: multiSelect("relationships[possible_allergen_ids][]"),
      internal_name: value('[name="[advanced][internal_name]"]'),
      reporting_category: value('[name="[advanced][reporting_category]"]'),
      primary_screen: value('[name="[advanced][primary_screen]"]'),
      secondary_screen: value('[name="[advanced][secondary_screen]"]'),
      modal_override: value('[name="[advanced][modal_override]"]'),
      menu_appearance_id: value('[name="[advanced][menu_appearance_id]"]'),
      delivery_tax_rate: value('[name="[advanced][delivery_tax_rate]"]'),
      takeaway_tax_rate: value('[name="[advanced][takeaway_tax_rate]"]'),
      eat_in_tax_rate: value('[name="[advanced][eat_in_tax_rate]"]'),
      cost_price: value('[name="[advanced][cost_price]"]'),
      stock_warning_threshold: value('[name="[advanced][stock_warning_threshold]"]'),
      stock_items: this.stockItemsModeActive ? JSON.stringify(this.stockItemsPayload()) : "",
      image_url: this.persistedImageUrl || "",
      cropped_image: value(".cropped_image_identifier"),
      video_url: this.persistedVideoUrl || "",
      video_file: this.hasVideoInputTarget ? this.videoInputTarget.value : "",
      remove_video: checked('input[type="checkbox"][name="[details][remove_video]"]'),
    })
  }

  captureFormSnapshot() {
    this.formSnapshot = this.serializeFormState()
  }

  hasUnsavedChanges() {
    const formChanged = this.formSnapshot !== undefined && this.serializeFormState() !== this.formSnapshot
    const modifiersChanged =
      (this.assignedModifierGroups && this.assignedModifierGroups.length > 0) ||
      (this.removedModifierCollectionIds && this.removedModifierCollectionIds.length > 0)

    return formChanged || modifiersChanged
  }

  setDrawerTitle(title) {
    if (!this.hasTitleTarget) return

    this.titleTarget.textContent = title
  }

  resetDrawerTitle() {
    if (!this.defaultDrawerTitle) return

    this.setDrawerTitle(this.defaultDrawerTitle)
  }

  // --- Modifiers methods ---
  showModifierTypeChooser(event) {
    event.preventDefault()
    this.clearCurrentModifierEditState()
    this.setModifierPanel("typeChooser")
  }

  showExistingModifierSearch(event) {
    event.preventDefault()
    this.clearCurrentModifierEditState()
    this.clearExistingModifierSearch()
    this.setModifierPanel("search")
  }

  backToHome(event) {
    event.preventDefault()
    this.setModifierPanel("home")
  }

  showModifierGroupForm(event) {
    event.preventDefault()

    if (Object.prototype.hasOwnProperty.call(event.currentTarget.dataset, "modifierType")) {
      this.currentModifierType = event.currentTarget.dataset.modifierType || null
    }

    this.updateModifierGroupFormCopy()

    // Re-open the last assigned values for this modifier type so the user can
    // continue editing the same group after coming back from the home screen.
    if (event.currentTarget.dataset.resetDraft === "true") {
      const assignedGroup = this.findAssignedModifierGroup(this.currentModifierType)

      if (assignedGroup) {
        this.setCurrentModifierEditStateFromGroup(assignedGroup)
        this.loadAssignedModifierGroupIntoDraft(assignedGroup)
      } else {
        this.clearCurrentModifierEditState()
        this.resetModifierDraft()
      }
    }

    this.setModifierPanel("groupForm")
  }

  editCurrentModifier(event) {
    event.preventDefault()

    const { modifierId, itemableId, itemableType, modifierType, showOnPos } = event.currentTarget.dataset
    const stagedModifierGroup = this.findStagedAssignedModifierGroup({ modifierId, itemableId, itemableType })
    const sourceModifierGroup = stagedModifierGroup || this.findExistingModifierGroup(itemableId, itemableType)

    console.log("Editing modifier group with data:", { modifierId, itemableId, itemableType, modifierType })
    console.log("stagedModifierGroup:", stagedModifierGroup)
    console.log("sourceModifierGroup:", sourceModifierGroup)

    if (!sourceModifierGroup) {
      this.setStatus("Unable to load this modifier for editing.", "error")
      return
    }

    this.openModifierGroupEditor({
      ...sourceModifierGroup,
      show_on_pos: this.booleanValue(showOnPos, sourceModifierGroup?.show_on_pos),
    }, {
      modifierId,
      itemableId,
      itemableType,
      modifierType,
    })
  }

  editAssignedModifierGroup(event) {
    event.preventDefault()

    const { modifierId, localModifierId, itemableId, itemableType, modifierType } = event.currentTarget.dataset
    const modifierGroup = this.findStagedAssignedModifierGroup({
      modifierId,
      localModifierId,
      itemableId,
      itemableType,
    })

    if (!modifierGroup) {
      this.setStatus("Unable to reopen this staged modifier.", "error")
      return
    }

    this.openModifierGroupEditor(modifierGroup, {
      modifierId,
      localModifierId,
      itemableId,
      itemableType,
      modifierType,
    })
  }

  filterModifierProducts() {
    if (!this.hasModifierProductSearchInputTarget || !this.hasModifierProductSuggestionsTarget) return

    const query = this.modifierProductSearchInputTarget.value.trim().toLowerCase()
    delete this.modifierProductSearchInputTarget.dataset.selectedItemId

    const matches = this.modifierProductCatalog()
      .filter((item) => query.length === 0 || String(item.name || "").toLowerCase().includes(query))

    if (matches.length === 0) {
      this.modifierProductSuggestionsTarget.innerHTML = ""
      this.modifierProductSuggestionsTarget.hidden = true
      return
    }

    this.modifierProductSuggestionsTarget.innerHTML = matches.map((item) => `
      <button
        type="button"
        class="menu-v2-modifier-suggestion"
        data-action="click->menu-item-drawer#selectModifierProductSuggestion"
        data-item-id="${this.escapeHtml(item.id)}"
        data-item-name="${this.escapeHtml(item.name)}"
      >
        <span class="menu-v2-modifier-suggestion-label">${this.escapeHtml(item.name)}</span>
        ${this.modifierProductPriceDisplay(item) ? `<span class="menu-v2-modifier-suggestion-meta">${this.escapeHtml(this.modifierProductPriceDisplay(item))}</span>` : ""}
      </button>
    `).join("")

    this.modifierProductSuggestionsTarget.hidden = false
  }

  toggleModifierProductList(event) {
    if (event) event.preventDefault()
    if (!this.hasModifierProductSuggestionsTarget || !this.hasModifierProductSearchInputTarget) return

    if (this.modifierProductSuggestionsTarget.hidden) {
      this.filterModifierProducts()
      this.modifierProductSearchInputTarget.focus()
    } else {
      this.modifierProductSuggestionsTarget.hidden = true
    }
  }

  modifierProductCatalog() {
    if (this.currentModifierType === "extra" || this.currentModifierType === "upsell") {
      return this.optionCatalog.menu_items || []
    }

    return this.optionCatalog.items || []
  }

  modifierProductPriceDisplay(item) {
    return String(item.base_price_display || "").trim()
  }

  selectModifierProductSuggestion(event) {
    event.preventDefault()

    const { itemId, itemName } = event.currentTarget.dataset
    const optionState = this.buildOptionState({
      option_id: itemId || null,
      option_name: itemName || "",
    })

    if (!optionState.option_name && this.hasBlankDraftOption()) {
      this.resetOptionSearchResults()
      return
    }

    this.upsertDraftOption(optionState)
    this.resetOptionSearchResults()
  }

  filterExistingModifierGroups() {
    if (!this.hasExistingModifierSearchInputTarget || !this.hasExistingModifierSuggestionsTarget) return

    const query = this.existingModifierSearchInputTarget.value.trim().toLowerCase()

    const matches = this.existingModifierCatalog()
      .filter((group) => query.length === 0 || this.existingModifierSearchText(group).includes(query))

    if (matches.length === 0) {
      this.existingModifierSuggestionsTarget.innerHTML = ""
      this.existingModifierSuggestionsTarget.hidden = true
      return
    }

    this.existingModifierSuggestionsTarget.innerHTML = matches.map((group) => `
      <button
        type="button"
        class="menu-v2-modifier-suggestion"
        data-action="click->menu-item-drawer#selectExistingModifierGroup"
        data-group-id="${this.escapeHtml(group.id)}"
        data-itemable-type="${this.escapeHtml(group.itemable_type)}"
      >
        <span class="menu-v2-modifier-suggestion-label">${this.escapeHtml(group.modifier_name || "Modifier Group")}</span>
        <span class="menu-v2-modifier-suggestion-meta">
          ${this.escapeHtml(this.displayModifierType(group.modifier_type))} · ${this.escapeHtml(String(group.option_count || 0))} ${this.escapeHtml(this.modifierItemLabel(group.modifier_type, group.option_count || 0))}
        </span>
      </button>
    `).join("")

    this.existingModifierSuggestionsTarget.hidden = false
  }

  toggleExistingModifierList(event) {
    if (event) event.preventDefault()
    if (!this.hasExistingModifierSuggestionsTarget || !this.hasExistingModifierSearchInputTarget) return

    if (this.existingModifierSuggestionsTarget.hidden) {
      this.filterExistingModifierGroups()
      this.existingModifierSearchInputTarget.focus()
    } else {
      this.existingModifierSuggestionsTarget.hidden = true
    }
  }

  existingModifierCatalog() {
    return this.optionCatalog.modifier_groups || []
  }

  existingModifierSearchText(group) {
    return [
      group.modifier_name,
      group.internal_name,
      this.displayModifierType(group.modifier_type),
    ].join(" ").toLowerCase()
  }

  selectExistingModifierGroup(event) {
    event.preventDefault()

    const { groupId, itemableType } = event.currentTarget.dataset
    const modifierGroup = this.findExistingModifierGroup(groupId, itemableType)
    if (!modifierGroup) return

    this.upsertAssignedModifierGroup(this.buildExistingAssignedModifierGroup(modifierGroup))
    this.renderAssignedModifierGroups()
    this.setStatus("Modifier group assigned locally.", "success")
    this.setModifierPanel("home")

    this.clearExistingModifierSearch()
  }

  findExistingModifierGroup(groupId, itemableType) {

    console.log("this.existingModifierCatalog()", this.existingModifierCatalog(), groupId, itemableType)

    return this.existingModifierCatalog().find((group) => (
      String(group.id) === String(groupId) &&
      String(group.itemable_type) === String(itemableType)
    )) || null
  }

  setModifierPanel(panelName) {
    this.modifierHomeTarget.hidden = panelName !== "home"
    this.modifierSearchPanelTarget.hidden = panelName !== "search"
    this.modifierGroupFormTarget.hidden = panelName !== "groupForm"
    this.modifierTypeChooserTarget.hidden = panelName !== "typeChooser"
  }

  // --- New item template chooser ---

  showNewItemChoiceScreen() {
    if (!this.hasNewItemChoiceScreenTarget) return

    if (this.hasDrawerTabsTarget) this.drawerTabsTarget.hidden = true
    this.panel2Targets.forEach(panel => { panel.hidden = true })
    this.newItemChoiceScreenTarget.hidden = false
    if (this.hasTemplateSelectorScreenTarget) this.templateSelectorScreenTarget.hidden = true
    if (this.hasExistingItemSelectorScreenTarget) this.existingItemSelectorScreenTarget.hidden = true
  }

  selectBlankItem(event) {
    event.preventDefault()
    if (this.hasNewItemChoiceScreenTarget) this.newItemChoiceScreenTarget.hidden = true
    if (this.hasDrawerTabsTarget) this.drawerTabsTarget.hidden = false
    this.setActiveTab("1")
  }

  showTemplateSelector(event) {
    event.preventDefault()
    if (this.hasNewItemChoiceScreenTarget) this.newItemChoiceScreenTarget.hidden = true
    if (this.hasTemplateSelectorScreenTarget) this.templateSelectorScreenTarget.hidden = false
    this.renderTemplateList()
  }

  backToChoiceScreen(event) {
    event.preventDefault()
    if (this.hasTemplateSelectorScreenTarget) this.templateSelectorScreenTarget.hidden = true
    if (this.hasExistingItemSelectorScreenTarget) this.existingItemSelectorScreenTarget.hidden = true
    if (this.hasNewItemChoiceScreenTarget) this.newItemChoiceScreenTarget.hidden = false
  }

  showExistingItemSelector(event) {
    event.preventDefault()
    if (this.hasNewItemChoiceScreenTarget) this.newItemChoiceScreenTarget.hidden = true
    if (this.hasExistingItemSelectorScreenTarget) this.existingItemSelectorScreenTarget.hidden = false
    if (this.hasExistingItemSearchTarget) this.existingItemSearchTarget.value = ""
    this.refreshExistingPlacementsFromDom()
    this.renderExistingItemList("")
  }

  refreshExistingPlacementsFromDom() {
    const placementsById = new Map()
    document.querySelectorAll("#menu-v2-category-list .menu-v2-category-card").forEach((card) => {
      const titleEl = card.querySelector(".menu-v2-category-title")
      if (!titleEl) return
      const categoryName = titleEl.textContent.trim()
      card.querySelectorAll('[data-menu-item-id]').forEach((node) => {
        const id = node.dataset.menuItemId
        if (!id) return
        if (!placementsById.has(id)) placementsById.set(id, new Set())
        placementsById.get(id).add(categoryName)
      })
    })

    ;(this.optionCatalog.menu_items || []).forEach((item) => {
      const set = placementsById.get(String(item.id))
      item.existing_placements = set ? Array.from(set) : []
    })
  }

  renderExistingItemList(query) {
    if (!this.hasExistingItemListTarget) return

    const items = (this.optionCatalog.menu_items || [])
    const needle = query.trim().toLowerCase()
    const filtered = needle
      ? items.filter(item => (item.name || "").toLowerCase().includes(needle))
      : items.slice()

    filtered.sort((a, b) => (a.name || "").localeCompare(b.name || ""))

    this.existingItemListTarget.innerHTML = filtered.map(item => {
      const placements = item.existing_placements || []
      const internalLine = item.internal_name
        ? `<p class="menu-v2-existing-item-row__meta">${this.escapeHtml(item.internal_name)}</p>`
        : ""
      const placementLine = placements.length
        ? `<p class="menu-v2-existing-item-row__placement">Already in: ${this.escapeHtml(placements.join(", "))}</p>`
        : ""

      return `
        <article class="menu-v2-existing-item-row">
          <div class="menu-v2-existing-item-row__body">
            <p class="menu-v2-existing-item-row__name">${this.escapeHtml(item.name || "")}</p>
            ${internalLine}
            ${placementLine}
          </div>
          <div class="menu-v2-existing-item-row__side">
            <span class="menu-v2-existing-item-row__price">${this.escapeHtml(item.base_price_display || "")}</span>
            <button
              type="button"
              class="menu-v2-modifier-choice-btn menu-v2-existing-item-use-btn"
              data-action="click->menu-item-drawer#selectExistingItem"
              data-menu-item-id="${item.id}"
            >
              Add
            </button>
          </div>
        </article>
      `
    }).join("")

    if (this.hasExistingItemEmptyTarget) {
      this.existingItemEmptyTarget.hidden = filtered.length > 0
    }
  }

  filterExistingItems(event) {
    this.renderExistingItemList(event.currentTarget.value || "")
  }

  async selectExistingItem(event) {
    event.preventDefault()
    const button = event.currentTarget
    const menuItemId = button.dataset.menuItemId
    const categoryId = this.formTarget.querySelector('[name="category_id"]')?.value
    const restaurantId = this.activeTrigger?.dataset.restaurantId
    const menuId = this.getMenuId()

    if (!menuItemId || !categoryId || !restaurantId || !menuId) return

    button.disabled = true
    const previousLabel = button.textContent
    button.textContent = "Adding…"

    try {
      const response = await fetch(
        `/restaurants/${restaurantId}/v2/menus/${menuId}/categories/${categoryId}/menu_item_instances`,
        {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": this.csrfToken(),
          },
          body: JSON.stringify({ menu_item_id: menuItemId }),
        },
      )

      const data = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(data.error || "Failed to add item")

      if (data.markdown) {
        document.getElementById("menu-v2-category-counts").innerHTML = data.markdown
      }
      if (data.markdown_2) {
        document.getElementById("menu-v2-category-list").innerHTML = data.markdown_2
      }

      this.close()
    } catch (error) {
      console.error(error)
      button.textContent = previousLabel
      button.disabled = false
    }
  }

  renderTemplateList() {
    if (!this.hasTemplateListTarget || !this.cachedTemplates) return

    this.templateListTarget.innerHTML = this.cachedTemplates.map(template => `
      <article class="menu-v2-template-card">
        <div class="menu-v2-template-card-body">
          <h4 class="menu-v2-template-card-title">${this.escapeHtml(template.name)}</h4>
          ${template.groups.map(g => `
            <p class="menu-v2-template-card-summary">
              <strong>${this.escapeHtml(g.modifier_name)}</strong>: ${g.modifier_options.map(o => this.escapeHtml(o.option_name)).join(', ')}
            </p>
          `).join('')}
        </div>
        <button
          type="button"
          class="menu-v2-modifier-choice-btn menu-v2-template-card-btn"
          data-action="click->menu-item-drawer#selectTemplate"
          data-template-key="${this.escapeHtml(template.key)}"
        >
          Use Template
        </button>
      </article>
    `).join("")
  }

  selectTemplate(event) {
    event.preventDefault()
    const templateKey = event.currentTarget.dataset.templateKey
    const template = (this.cachedTemplates || []).find(t => t.key === templateKey)
    if (!template) return

    this.assignedModifierGroups = template.groups.map(group => ({
      modifier_type: group.modifier_type,
      modifier_name: group.modifier_name,
      modifier_id: null,
      local_modifier_id: this.buildLocalModifierId(),
      itemable_id: null,
      itemable_type: null,
      required: group.required,
      max_selection: group.max_selection,
      modifier_options: group.modifier_options.map(opt => ({ ...opt })),
    }))
    this.removedModifierCollectionIds = []
    this.renderAssignedModifierGroups()

    if (this.hasTemplateSelectorScreenTarget) this.templateSelectorScreenTarget.hidden = true
    if (this.hasDrawerTabsTarget) this.drawerTabsTarget.hidden = false
    this.setActiveTab("1")
  }
  
  removeItem(event) {
    event.preventDefault()
    const row = event.currentTarget.closest('tr')
    const tempOptionId = row?.dataset.tempOptionId

    if (tempOptionId) {
      this.tempstate = this.tempstate.filter((option) => String(option.temp_option_id) !== String(tempOptionId))
    }

    if (this.tempstate.length === 0) {
      this.tempstate = [this.buildDraftOptionState()]
    }

    this.renderModifierOptionRows()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  addNewOptionRow() {
    const optionState = this.buildOptionState({
      option_name: this.currentOptionName(),
      option_id: null,
    })

    if (!optionState.option_name && this.hasBlankDraftOption()) {
      this.resetOptionSearchResults()
      return
    }

    this.upsertDraftOption(optionState)
    this.resetOptionSearchResults()
  }

  addManualOptionRow(event) {
    if (event) event.preventDefault()

    this.tempstate.push(this.buildDraftOptionState())
    this.renderModifierOptionRows()
  }

  syncModifierOptionRow(event) {
    const input = event.currentTarget
    const row = input.closest("tr")
    const tempOptionId = row?.dataset.tempOptionId
    const field = input.dataset.field

    if (!tempOptionId || !field) return

    const option = this.tempstate.find((item) => String(item.temp_option_id) === String(tempOptionId))
    if (!option) return

    option[field] = input.value
  }

  assignModifierGroup(event) {
    event.preventDefault()

    const wasEditingModifier = this.hasActiveModifierEditState()
    const modifierGroup = this.buildAssignedModifierGroup()
    if (!modifierGroup) return

    this.upsertAssignedModifierGroup(modifierGroup)
    this.renderAssignedModifierGroups()
    if (modifierGroup.modifier_id) {
      this.replaceCurrentModifierMarkup(modifierGroup)
    }

    if (wasEditingModifier) {
      this.setStatus("Modifier group updated locally. Save the item to persist it.", "success")
    } else {
      this.setStatus("Modifier group assigned locally.", "success")
    }
    this.clearCurrentModifierEditState()
    this.setModifierPanel("home")
  }

  removeCurrentModifier(event) {
    event.preventDefault()

    const { modifierId, modifierName, localModifierId, itemableId, itemableType } = event.currentTarget.dataset

    if (!modifierId) {
      this.setStatus("Unable to remove this modifier right now.", "error")
      return
    }

    this.removePersistedModifierGroup({
      modifierId,
      modifierName,
      localModifierId,
      itemableId,
      itemableType,
    })
  }

  removeAssignedModifierGroup(event) {
    event.preventDefault()

    const { modifierId, modifierName, localModifierId, itemableId, itemableType } = event.currentTarget.dataset

    if (modifierId) {
      this.removePersistedModifierGroup({
        modifierId,
        modifierName,
        localModifierId,
        itemableId,
        itemableType,
      })
      return
    }

    const removed = this.dropAssignedModifierGroup({
      localModifierId,
      itemableId,
      itemableType,
    })

    if (!removed) {
      this.setStatus("Unable to remove this staged modifier right now.", "error")
      return
    }

    this.resetModifierDraftIfEditingMatch({
      localModifierId,
      itemableId,
      itemableType,
    })
    this.setStatus(`${modifierName || "Modifier group"} removed locally. Save the item to persist it.`, "success")
  }
  

  handleCroppedImageSelection(event) {
    const { fileName } = event.detail || {}

    this.setImagePickerButtonLabel(fileName ? `Image Selected (${fileName})` : "Image Selected")
  }

  resetImageState(existingImageUrl = "") {
    this.persistedImageUrl = existingImageUrl || ""
    this.clearCropperInputs()
    this.setImagePickerButtonLabel(this.defaultImagePickerLabel)
    this.renderImagePreview(this.persistedImageUrl)
  }

  // EM-2731. The item's video: what is saved, a newly chosen file, and the
  // option to remove it.
  resetVideoState(existingVideoUrl = "") {
    this.persistedVideoUrl = existingVideoUrl || ""
    if (this.hasVideoInputTarget) this.videoInputTarget.value = ""
    if (this.hasRemoveVideoToggleTarget) {
      const removeCheckbox = this.removeVideoToggleTarget.querySelector('input[type="checkbox"]')
      if (removeCheckbox) removeCheckbox.checked = false
      this.removeVideoToggleTarget.hidden = !this.persistedVideoUrl
    }
    this.renderVideoPreview(this.persistedVideoUrl)
  }

  renderVideoPreview(videoUrl = "") {
    if (!this.hasVideoPreviewTarget) return

    if (!videoUrl) {
      this.videoPreviewTarget.innerHTML = `<div class="menu-v2-drawer-image-placeholder">No video added.</div>`
      return
    }

    this.videoPreviewTarget.innerHTML = `
      <video src="${this.escapeHtml(videoUrl)}" muted loop playsinline controls preload="metadata" style="max-width: 100%;"></video>
    `
  }

  // Says straight away when a file is too big or not a video, rather than after
  // the upload. The server checks the same limits.
  checkVideoFile(event) {
    const input = event.target
    const file = input.files && input.files[0]
    if (!file) return

    const maxBytes = Number(input.dataset.maxBytes || 0)
    const allowedTypes = (input.getAttribute("accept") || "").split(",")
    let problem = null
    if (allowedTypes.length && !allowedTypes.includes(file.type)) {
      problem = "That file is not an MP4 or WebM video."
    } else if (maxBytes && file.size > maxBytes) {
      problem = `That video is ${(file.size / 1048576).toFixed(1)} MB; the limit is ${Math.round(maxBytes / 1048576)} MB.`
    }

    if (problem) {
      input.value = ""
      this.setStatus(problem, "error")
      return
    }

    this.renderVideoPreview(URL.createObjectURL(file))
  }

  clearCropperInputs() {
    if (this.hasCropDetailsTarget) {
      this.cropDetailsTarget.value = ""
    }

    const croppedImageInput = this.formTarget.querySelector(".cropped_image_identifier")
    if (croppedImageInput) {
      croppedImageInput.value = ""
    }
  }

  setImagePickerButtonLabel(label) {
    if (!this.hasImagePickerButtonTarget) return

    this.imagePickerButtonTarget.textContent = label
  }

  renderImagePreview(imageUrl = "") {
    if (!this.hasImagePreviewTarget) return

    if (!imageUrl) {
      this.imagePreviewTarget.innerHTML = `<div class="menu-v2-drawer-image-placeholder">No image selected yet.</div>`
      return
    }

    this.imagePreviewTarget.innerHTML = `
      <img src="${this.escapeHtml(imageUrl)}" alt="Selected image preview">
    `
  }

  unlockBody() {
    if (!document.querySelector(".menu-v2-drawer.is-open")) {
      document.body.classList.remove("menu-v2-drawer-open")
    }
  }

  applyDefaultSettings() {
    const form = document.querySelector("[data-default-settings-form]")
    if (!form) return

    form.querySelectorAll("[data-default-key]").forEach((sourceField) => {
      const key = sourceField.dataset.defaultKey
      const value = sourceField.value
      if (!value) return

      const drawerField = this.formTarget.querySelector(`[name="[advanced][${key}]"]`)
      if (drawerField) drawerField.value = value
    })
  }

  async saveDefaultSettings(event) {
    event.preventDefault()

    const form = event.currentTarget
    const statusEl = form.querySelector("[data-default-settings-status]")
    const submitBtn = form.querySelector("[data-default-settings-submit]")

    if (statusEl) {
      statusEl.textContent = "Saving…"
      statusEl.className = "menu-v2-default-settings-status"
    }
    if (submitBtn) submitBtn.disabled = true

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: new FormData(form),
      })

      if (!response.ok) throw new Error("Failed to save")

      this.notifyMenuChanged()

      if (statusEl) {
        statusEl.textContent = "Saved!"
        statusEl.classList.add("is-success")
        setTimeout(() => {
          statusEl.textContent = ""
          statusEl.classList.remove("is-success")
        }, 2500)
      }
    } catch (_error) {
      if (statusEl) {
        statusEl.textContent = "Could not save. Please try again."
        statusEl.classList.add("is-error")
      }
    } finally {
      if (submitBtn) submitBtn.disabled = false
    }
  }

  parseOptionCatalog() {
    const catalogElement = this.element.querySelector("#menu-v2-drawer-option-catalog")
    if (!catalogElement) return { stock_item_dictionaries_enabled: false }

    try {
      return JSON.parse(catalogElement.textContent)
    } catch (_error) {
      return { stock_item_dictionaries_enabled: false }
    }
  }

  parseMenuItemTemplates() {
    const el = this.element.querySelector("#menu-v2-item-templates")
    if (!el) return []

    try {
      return JSON.parse(el.textContent)
    } catch (_error) {
      return []
    }
  }

  resetLocalModifierState() {
    this.assignedModifierGroups = []
    this.removedModifierCollectionIds = []
    this.currentModifierType = null
    this.clearCurrentModifierEditState()
    this.updateModifierGroupFormCopy()
    this.resetModifierDraft()
    this.clearExistingModifierSearch()
    this.renderAssignedModifierGroups()
  }

  resetModifierDraft() {
    this.tempstate = [this.buildDraftOptionState()]

    const nameInput = this.modifierGroupField("option_name")
    if (nameInput) nameInput.value = ""

    const requiredInput = this.modifierGroupField("required")
    if (requiredInput) requiredInput.checked = false

    const showOnPosInput = this.modifierGroupField("show_on_pos")
    if (showOnPosInput) showOnPosInput.checked = true

    const maxSelectionInput = this.modifierGroupField("max_selection")
    if (maxSelectionInput) maxSelectionInput.value = "1"

    this.clearModifierProductSearch()
    this.renderModifierOptionRows()
  }

  resetModifierDraftAfterSave() {
    this.assignedModifierGroups = []
    this.removedModifierCollectionIds = []
    this.clearCurrentModifierEditState()
    this.renderAssignedModifierGroups()
    this.resetModifierDraft()
  }

  buildDraftOptionState(overrides = {}) {
    return {
      temp_option_id: overrides.temp_option_id || `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      option_id: overrides.option_id || null,
      option_name: overrides.option_name || "",
      option_quantity: String(overrides.option_quantity ?? 1),
      option_price_adjustment: String(overrides.option_price_adjustment ?? "0.00"),
    }
  }

  buildLocalModifierId() {
    return `draft-modifier-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
  }

  currentOptionName() {
    const searchInput = this.hasModifierProductSearchInputTarget ? this.modifierProductSearchInputTarget : null
    return searchInput ? searchInput.value.trim() : ""
  }

  buildOptionState({ option_id = null, option_name = "" }) {
    return this.buildDraftOptionState({
      option_id,
      option_name,
      option_quantity: 1,
      option_price_adjustment: "0.00",
    })
  }

  hasBlankDraftOption() {
    return Boolean(this.emptyDraftOption())
  }

  emptyDraftOption() {
    return this.tempstate.find((option) => this.isBlankDraftOption(option))
  }

  upsertDraftOption(optionState) {
    const emptyDraftOption = this.emptyDraftOption()

    if (optionState.option_name && emptyDraftOption) {
      Object.assign(emptyDraftOption, optionState)
      return
    }

    this.tempstate.push(optionState)
  }

  resetOptionSearchResults() {
    this.clearModifierProductSearch()
    this.renderModifierOptionRows()
  }

  renderModifierOptionRows() {
    if (!this.hasNewOptionItemsTarget) return

    this.newOptionItemsTarget.innerHTML = this.tempstate.map((option) => this.modifierOptionRowMarkup(option)).join("")
  }

  modifierOptionRowMarkup(option) {
    const nameInputDisabled = option.option_id ? "disabled" : ""
    const optionValuePlaceholder = this.escapeHtml(this.modifierOptionValuePlaceholder())
    const optionPriceDisplay = this.escapeHtml(this.modifierOptionPriceDisplay(option))

    return `
      <tr data-temp-option-id="${this.escapeHtml(option.temp_option_id)}">
        <td>
          <input
            type="text"
            name="new_item_name[]"
            class="menu-v2-input"
            placeholder="${optionValuePlaceholder}"
            value="${this.escapeHtml(option.option_name)}"
            ${nameInputDisabled}
            data-field="option_name"
            data-action="input->menu-item-drawer#syncModifierOptionRow"
          />
        </td>
        <td>
          <input
            type="text"
            value="${optionPriceDisplay}"
            class="input-price input-price-readonly"
            readonly
            tabindex="-1"
          />
        </td>
        <td>
          <input
            type="number"
            value="${this.escapeHtml(option.option_quantity)}"
            min="0"
            name="new_item_max[]"
            class="input-qty"
            data-field="option_quantity"
            data-action="input->menu-item-drawer#syncModifierOptionRow"
          />
        </td>
        <td>
          <input
            type="number"
            value="${this.escapeHtml(option.option_price_adjustment)}"
            step="0.1"
            name="new_item_price[]"
            class="input-price"
            data-field="option_price_adjustment"
            data-action="input->menu-item-drawer#syncModifierOptionRow"
          />
        </td>
        <td>
          <button type="button" class="remove-btn" data-action="click->menu-item-drawer#removeItem" aria-label="Remove" title="Remove">
            &times;
          </button>
        </td>
      </tr>
    `
  }

  modifierOptionPriceDisplay(option) {
    if (!option.option_id) return ""

    const matchedItem = this.modifierProductCatalog().find((item) => String(item.id) === String(option.option_id))
    return matchedItem ? this.modifierProductPriceDisplay(matchedItem) : ""
  }

  isBlankDraftOption(option) {
    return String(option.option_name || "").trim() === ""
  }

  buildAssignedModifierGroup() {
    const modifierName = this.modifierGroupValue("option_name").trim()
    const modifierOptions = this.normalizedModifierOptions()
    const modifierId = this.editingModifierCollectionId
    const localModifierId = this.editingModifierLocalId || (!modifierId && !this.editingModifierItemableId && !this.editingModifierItemableType ? this.buildLocalModifierId() : null)
    const itemableId = this.editingModifierItemableId
    const itemableType = this.editingModifierItemableType

    if (modifierName.length === 0 && modifierOptions.length === 0) {
      this.setStatus(`Add a group name or at least one ${this.modifierItemLabel(this.currentModifierType)} before assigning.`, "error")
      return null
    }

    return {
      modifier_type: this.currentModifierType,
      modifier_name: modifierName,
      modifier_id: modifierId,
      local_modifier_id: localModifierId,
      itemable_id: itemableId,
      itemable_type: itemableType,
      required: this.modifierCheckboxValue("required"),
      show_on_pos: this.modifierCheckboxValue("show_on_pos"),
      max_selection: this.modifierGroupValue("max_selection").trim() || "1",
      modifier_options: modifierOptions,
    }
  }

  normalizedModifierOptions() {
    return this.tempstate
      .filter((option) => String(option.option_name || "").trim().length > 0)
      .map((option) => ({
        option_id: option.option_id || null,
        option_name: String(option.option_name || "").trim(),
        option_quantity: String(option.option_quantity || "1"),
        option_price_adjustment: String(option.option_price_adjustment || "0.00"),
      }))
  }

  findAssignedModifierGroup(modifierType) {
    for (let index = this.assignedModifierGroups.length - 1; index >= 0; index -= 1) {
      const group = this.assignedModifierGroups[index]
      if (String(group?.modifier_type || "") === String(modifierType || "")) {
        return group
      }
    }

    return null
  }

  upsertAssignedModifierGroup(modifierGroup) {
    this.untrackRemovedModifierCollection(modifierGroup.modifier_id)

    const existingIndex = this.findAssignedModifierGroupIndex(modifierGroup)

    if (existingIndex >= 0) {
      this.assignedModifierGroups.splice(existingIndex, 1, modifierGroup)
      return
    }

    this.assignedModifierGroups.push(modifierGroup)
  }

  dropAssignedModifierGroup({ modifierId = null, localModifierId = null, itemableId = null, itemableType = null } = {}) {
    const initialCount = this.assignedModifierGroups.length

    this.assignedModifierGroups = this.assignedModifierGroups.filter((group) => {
      return !this.assignedModifierGroupMatches(group, {
        modifierId,
        localModifierId,
        itemableId,
        itemableType,
      })
    })

    this.renderAssignedModifierGroups()
    return this.assignedModifierGroups.length !== initialCount
  }

  loadAssignedModifierGroupIntoDraft(modifierGroup) {
    const nameInput = this.modifierGroupField("option_name")
    if (nameInput) nameInput.value = modifierGroup.modifier_name || ""

    const requiredInput = this.modifierGroupField("required")
    if (requiredInput) requiredInput.checked = Boolean(modifierGroup.required)

    const showOnPosInput = this.modifierGroupField("show_on_pos")
    if (showOnPosInput) showOnPosInput.checked = this.booleanValue(modifierGroup.show_on_pos, true)

    const maxSelectionInput = this.modifierGroupField("max_selection")
    if (maxSelectionInput) maxSelectionInput.value = modifierGroup.max_selection || "1"

    this.tempstate = modifierGroup.modifier_options.length > 0
      ? modifierGroup.modifier_options.map((option) => this.buildDraftOptionState({
          option_id: option.option_id || null,
          option_name: option.option_name || "",
          option_quantity: option.option_quantity || "1",
          option_price_adjustment: option.option_price_adjustment || "0.00",
        }))
      : [this.buildDraftOptionState()]

    this.clearModifierProductSearch()
    this.renderModifierOptionRows()
  }

  renderAssignedModifierGroups() {
    if (!this.hasAssignedModifierGroupsListTarget) return

    if (this.assignedModifierGroups.length === 0) {
      this.assignedModifierGroupsListTarget.innerHTML = ""
      this.assignedModifierGroupsListTarget.hidden = true
      return
    }

    const cards = this.assignedModifierGroups.map((group, index) => this.assignedModifierGroupMarkup(group, index)).join("")

    this.assignedModifierGroupsListTarget.innerHTML = `
      <div class="menu-v2-assigned-modifiers-title">Assigned in this session</div>
      <div class="menu-v2-assigned-modifiers-grid">
        ${cards}
      </div>
    `
    this.assignedModifierGroupsListTarget.hidden = false
  }

  findAssignedModifierGroupIndex(modifierGroup) {
    const modifierId = modifierGroup.modifier_id || null
    const localModifierId = this.assignedModifierGroupLocalId(modifierGroup)
    const itemableId = this.assignedModifierGroupItemableId(modifierGroup)
    const itemableType = this.assignedModifierGroupItemableType(modifierGroup)

    return this.assignedModifierGroups.findIndex((group) => this.assignedModifierGroupMatches(group, {
      modifierId,
      localModifierId,
      itemableId,
      itemableType,
    }))
  }

  findStagedAssignedModifierGroup({ modifierId = null, localModifierId = null, itemableId = null, itemableType = null } = {}) {
    return this.assignedModifierGroups.find((group) => this.assignedModifierGroupMatches(group, {
      modifierId,
      localModifierId,
      itemableId,
      itemableType,
    })) || null
  }

  assignedModifierGroupMatches(group, { modifierId = null, localModifierId = null, itemableId = null, itemableType = null } = {}) {
    if (!group) return false

    if (modifierId) {
      return String(group.modifier_id || "") === String(modifierId)
    }

    if (localModifierId) {
      return String(this.assignedModifierGroupLocalId(group) || "") === String(localModifierId)
    }

    if (!itemableId || !itemableType) return false

    return (
      String(this.assignedModifierGroupItemableId(group) || "") === String(itemableId) &&
      String(this.assignedModifierGroupItemableType(group) || "") === String(itemableType)
    )
  }

  assignedModifierGroupItemableId(group) {
    return group?.itemable_id || group?.id || null
  }

  assignedModifierGroupLocalId(group) {
    return group?.local_modifier_id || null
  }

  assignedModifierGroupItemableType(group) {
    return group?.itemable_type || this.itemableTypeForModifierType(group?.modifier_type) || null
  }

  assignedModifierGroupMarkup(group, index) {
    const groupName = group.modifier_name || `Modifier Group ${index + 1}`
    const modifierType = this.displayModifierType(group.modifier_type)
    const optionCount = group.modifier_options.length
    const optionLabel = this.modifierItemLabel(group.modifier_type, optionCount)
    const requiredLabel = group.required ? "Required" : "Optional"
    const modifierId = this.escapeHtml(group.modifier_id || "")
    const localModifierId = this.escapeHtml(this.assignedModifierGroupLocalId(group) || "")
    const itemableId = this.escapeHtml(this.assignedModifierGroupItemableId(group) || "")
    const itemableType = this.escapeHtml(this.assignedModifierGroupItemableType(group) || "")
    const optionsMarkup = group.modifier_options.length > 0
      ? group.modifier_options.map((option) => `
          <span class="menu-v2-assigned-modifier-option">
            ${this.escapeHtml(option.option_name)}
          </span>
        `).join("")
      : `<span class="menu-v2-assigned-modifier-empty">No ${this.escapeHtml(this.modifierItemLabel(group.modifier_type, 2))} added yet.</span>`

    return `
      <article class="menu-v2-assigned-modifier-card">
        <div class="menu-v2-assigned-modifier-header">
          <div>
            <div class="menu-v2-assigned-modifier-name">${this.escapeHtml(groupName)}</div>
            <div class="menu-v2-assigned-modifier-meta">
              ${this.escapeHtml(modifierType)} · ${this.escapeHtml(requiredLabel)} · Max ${this.escapeHtml(group.max_selection || "1")} · ${this.escapeHtml(String(optionCount))} ${this.escapeHtml(optionLabel)}
            </div>
          </div>
          <div class="menu-v2-assigned-modifier-actions">
            <button
              type="button"
              class="menu-v2-outline-btn menu-v2-assigned-modifier-edit-btn"
              data-action="click->menu-item-drawer#editAssignedModifierGroup"
              data-modifier-id="${modifierId}"
              data-local-modifier-id="${localModifierId}"
              data-itemable-id="${itemableId}"
              data-itemable-type="${itemableType}"
              data-modifier-type="${this.escapeHtml(group.modifier_type || "")}"
              aria-label="Edit ${this.escapeHtml(groupName)}"
            >
              Edit
            </button>

            <button
              type="button"
              class="menu-v2-outline-btn menu-v2-assigned-modifier-remove-btn"
              data-action="click->menu-item-drawer#removeAssignedModifierGroup"
              data-modifier-id="${modifierId}"
              data-local-modifier-id="${localModifierId}"
              data-itemable-id="${itemableId}"
              data-itemable-type="${itemableType}"
              data-modifier-name="${this.escapeHtml(groupName)}"
              aria-label="Remove ${this.escapeHtml(groupName)}"
            >
              Remove
            </button>
          </div>
        </div>
        <div class="menu-v2-assigned-modifier-options">
          ${optionsMarkup}
        </div>
      </article>
    `
  }

  displayModifierType(modifierType) {
    if (modifierType === "options") return "Options"
    if (modifierType === "extra") return "Extra"
    if (modifierType === "upsell") return "Upsell"
    return "Custom"
  }

  displayModifierItemableType(itemableType) {
    if (itemableType === "ItemSet") return "Item set"
    if (itemableType === "MenuItemSet") return "Menu item set"
    if (itemableType === "ItemRuleSet") return "Item rule set"
    return "Modifier"
  }

  displayModifierPosState(showOnPos) {
    return showOnPos === false ? "Hidden on POS" : "Shown on POS"
  }

  itemableTypeForModifierType(modifierType) {
    if (modifierType === "options") return "ItemSet"
    if (modifierType === "extra" || modifierType === "upsell") return "MenuItemSet"
    return null
  }

  modifierItemLabel(modifierType, count = 1) {
    const plural = count !== 1

    if (modifierType === "options") return plural ? "options" : "option"
    if (modifierType === "extra") return plural ? "extras" : "extra"
    if (modifierType === "upsell") return plural ? "upsells" : "upsell"

    return plural ? "modifiers" : "modifier"
  }

  modifierTypeCopy() {
    if (this.currentModifierType === "options") {
      return {
        singular: "Option",
        groupPlaceholder: "e.g. Choice of Sauce",
        valuePlaceholder: "Option value (e.g. Mild)",
      }
    }

    if (this.currentModifierType === "extra") {
      return {
        singular: "Extra",
        groupPlaceholder: "e.g. Add Extra Cheese",
        valuePlaceholder: "Extra value (e.g. Cheese)",
      }
    }

    if (this.currentModifierType === "upsell") {
      return {
        singular: "Upsell",
        groupPlaceholder: "e.g. Add a Drink",
        valuePlaceholder: "Upsell value (e.g. Soft Drink)",
      }
    }

    return {
      singular: "Modifier",
      groupPlaceholder: "e.g. Modifier Group",
      valuePlaceholder: "Modifier value",
    }
  }

  updateModifierGroupFormCopy() {
    if (!this.hasModifierGroupFormTarget) return

    const copy = this.modifierTypeCopy()
    const title = this.modifierGroupFormTarget.querySelector('[data-modifier-copy="group-title"]')
    const nameLabel = this.modifierGroupFormTarget.querySelector('[data-modifier-copy="group-name-label"]')
    const addRowButton = this.modifierGroupFormTarget.querySelector('[data-modifier-copy="add-row-button"]')
    const nameInput = this.modifierGroupField("option_name")

    if (title) title.textContent = `Build ${copy.singular} Group`
    if (nameLabel) nameLabel.textContent = `Name Your ${copy.singular} Group`
    if (addRowButton) addRowButton.textContent = `+ Add ${copy.singular}`
    if (nameInput) nameInput.placeholder = copy.groupPlaceholder
  }

  modifierOptionValuePlaceholder() {
    return this.modifierTypeCopy().valuePlaceholder
  }

  modifierGroupField(name) {
    if (!this.hasModifierGroupFormTarget) return null

    return this.modifierGroupFormTarget.querySelector(`[name="${name}"]`)
  }

  modifierGroupValue(name) {
    const field = this.modifierGroupField(name)
    return field ? field.value : ""
  }

  modifierCheckboxValue(name) {
    const field = this.modifierGroupField(name)
    return Boolean(field && field.checked)
  }

  booleanValue(value, fallback = true) {
    if (value === undefined || value === null || value === "") return fallback
    if (typeof value === "boolean") return value
    return String(value).toLowerCase() === "true"
  }

  clearModifierProductSearch() {
    if (this.hasModifierProductSearchInputTarget) {
      this.modifierProductSearchInputTarget.value = ""
      delete this.modifierProductSearchInputTarget.dataset.selectedItemId
    }

    if (this.hasModifierProductSuggestionsTarget) {
      this.modifierProductSuggestionsTarget.innerHTML = ""
      this.modifierProductSuggestionsTarget.hidden = true
    }
  }

  clearExistingModifierSearch() {
    if (this.hasExistingModifierSearchInputTarget) {
      this.existingModifierSearchInputTarget.value = ""
    }

    if (this.hasExistingModifierSuggestionsTarget) {
      this.existingModifierSuggestionsTarget.innerHTML = ""
      this.existingModifierSuggestionsTarget.hidden = true
    }
  }

  clearCurrentModifierEditState() {
    this.editingModifierCollectionId = null
    this.editingModifierLocalId = null
    this.editingModifierItemableId = null
    this.editingModifierItemableType = null
  }

  setCurrentModifierEditState({ modifierId = null, localModifierId = null, itemableId = null, itemableType = null } = {}) {
    this.editingModifierCollectionId = modifierId ? String(modifierId) : null
    this.editingModifierLocalId = localModifierId ? String(localModifierId) : null
    this.editingModifierItemableId = itemableId ? String(itemableId) : null
    this.editingModifierItemableType = itemableType || null
  }

  setCurrentModifierEditStateFromGroup(group) {
    this.setCurrentModifierEditState({
      modifierId: group?.modifier_id || null,
      localModifierId: this.assignedModifierGroupLocalId(group),
      itemableId: this.assignedModifierGroupItemableId(group),
      itemableType: this.assignedModifierGroupItemableType(group),
    })
  }

  hasActiveModifierEditState() {
    return Boolean(
      this.editingModifierCollectionId ||
      this.editingModifierLocalId ||
      (this.editingModifierItemableId && this.editingModifierItemableType)
    )
  }

  buildExistingAssignedModifierGroup(modifierGroup) {
    return {
      ...modifierGroup,
      modifier_id: null,
      local_modifier_id: null,
      itemable_id: modifierGroup.id,
      itemable_type: modifierGroup.itemable_type,
    }
  }

  openModifierGroupEditor(modifierGroup, {
    modifierId = null,
    localModifierId = null,
    itemableId = null,
    itemableType = null,
    modifierType = null,
  } = {}) {
    const resolvedModifierType = modifierType || modifierGroup.modifier_type || null
    const resolvedModifierId = modifierId || modifierGroup.modifier_id || null
    const resolvedLocalModifierId = localModifierId || this.assignedModifierGroupLocalId(modifierGroup)
    const resolvedItemableId = itemableId || this.assignedModifierGroupItemableId(modifierGroup)
    const resolvedItemableType = itemableType || this.assignedModifierGroupItemableType(modifierGroup)

    this.currentModifierType = resolvedModifierType
    this.setCurrentModifierEditState({
      modifierId: resolvedModifierId,
      localModifierId: resolvedLocalModifierId,
      itemableId: resolvedItemableId,
      itemableType: resolvedItemableType,
    })
    this.updateModifierGroupFormCopy()
    this.loadAssignedModifierGroupIntoDraft({
      ...modifierGroup,
      modifier_type: resolvedModifierType,
      modifier_id: resolvedModifierId,
      local_modifier_id: resolvedLocalModifierId,
      itemable_id: resolvedItemableId,
      itemable_type: resolvedItemableType,
    })
    this.setModifierPanel("groupForm")
  }

  replaceCurrentModifierMarkup(modifierGroup) {
    const currentModifierElement = this.findCurrentModifierElement(modifierGroup.modifier_id)
    if (!currentModifierElement) return

    currentModifierElement.insertAdjacentHTML("afterend", this.currentModifierMarkup(modifierGroup))
    currentModifierElement.remove()
  }

  findCurrentModifierElement(modifierId) {
    if (!modifierId) return null

    const currentModifiersContainer = this.currentModifiersContainer()
    if (!currentModifiersContainer) return null

    return Array.from(currentModifiersContainer.querySelectorAll("[data-current-modifier-id]")).find((element) => (
      String(element.dataset.currentModifierId || "") === String(modifierId)
    )) || null
  }

  currentModifiersContainer() {
    return document.getElementById("menu-v2-current-modifiers")
  }

  clearCurrentModifiers() {
    const currentModifiersContainer = this.currentModifiersContainer()
    if (!currentModifiersContainer) return

    currentModifiersContainer.innerHTML = this.currentModifierEmptyMarkup()
  }

  removeCurrentModifierMarkupById(modifierId) {
    const currentModifierElement = this.findCurrentModifierElement(modifierId)
    if (currentModifierElement) {
      currentModifierElement.remove()
    }

    this.renderCurrentModifiersEmptyStateIfNeeded()
  }

  renderCurrentModifiersEmptyStateIfNeeded() {
    const currentModifiersContainer = this.currentModifiersContainer()
    if (!currentModifiersContainer) return

    const remainingModifiers = currentModifiersContainer.querySelectorAll("[data-current-modifier-id]")
    if (remainingModifiers.length === 0) {
      currentModifiersContainer.innerHTML = this.currentModifierEmptyMarkup()
    }
  }

  currentModifierEmptyMarkup() {
    return `<p class="menu-v2-current-modifiers-empty">No modifiers attached.</p>`
  }

  currentModifierMarkup(modifierGroup) {
    const modifierId = this.escapeHtml(modifierGroup.modifier_id || "")
    const modifierName = this.escapeHtml(modifierGroup.modifier_name || "Modifier Group")
    const modifierType = modifierGroup.modifier_type || "custom"
    const itemableId = this.escapeHtml(this.assignedModifierGroupItemableId(modifierGroup) || "")
    const itemableType = this.assignedModifierGroupItemableType(modifierGroup)
    const escapedItemableType = this.escapeHtml(itemableType || "")
    const showOnPos = this.booleanValue(modifierGroup.show_on_pos, true)

    return `
      <li class="menu-v2-current-modifiers-list__item" data-current-modifier-id="${modifierId}">
        <div class="menu-v2-current-modifiers-list__details">
          <span class="menu-v2-current-modifiers-list__name">
            ${modifierName}
          </span>
          <span class="menu-v2-current-modifiers-list__meta">
            <span class="menu-v2-current-modifiers-list__type">
              ${this.escapeHtml(this.displayModifierType(modifierType))}
            </span>
            <span class="menu-v2-current-modifiers-list__type">
              ${this.escapeHtml(this.displayModifierItemableType(itemableType))}
            </span>
          </span>
        </div>

        <div class="menu-v2-current-modifiers-list__actions">
          <button
            type="button"
            class="menu-v2-outline-btn menu-v2-current-modifiers-list__edit-btn"
            data-action="click->menu-item-drawer#editCurrentModifier"
            data-modifier-id="${modifierId}"
            data-itemable-id="${itemableId}"
            data-itemable-type="${escapedItemableType}"
            data-modifier-type="${this.escapeHtml(modifierType)}"
            data-show-on-pos="${showOnPos}"
            aria-label="Edit ${modifierName}"
          >
            Edit
          </button>

          <button
            type="button"
            class="menu-v2-outline-btn menu-v2-current-modifiers-list__remove-btn"
            data-action="click->menu-item-drawer#removeCurrentModifier"
            data-modifier-id="${modifierId}"
            data-itemable-id="${itemableId}"
            data-itemable-type="${escapedItemableType}"
            data-modifier-name="${modifierName}"
            aria-label="Remove ${modifierName}"
          >
            Remove
          </button>
        </div>
      </li>
    `
  }

  trackRemovedModifierCollection(modifierId) {
    if (!modifierId) return

    const normalizedId = String(modifierId)
    if (this.removedModifierCollectionIds.includes(normalizedId)) return

    this.removedModifierCollectionIds.push(normalizedId)
  }

  untrackRemovedModifierCollection(modifierId) {
    if (!modifierId) return

    this.removedModifierCollectionIds = this.removedModifierCollectionIds.filter((id) => (
      String(id) !== String(modifierId)
    ))
  }

  removePersistedModifierGroup({
    modifierId = null,
    modifierName = null,
    localModifierId = null,
    itemableId = null,
    itemableType = null,
  } = {}) {
    if (!modifierId) return false

    this.trackRemovedModifierCollection(modifierId)
    this.dropAssignedModifierGroup({ modifierId, localModifierId, itemableId, itemableType })
    this.resetModifierDraftIfEditingMatch({ modifierId, localModifierId, itemableId, itemableType })
    this.removeCurrentModifierMarkupById(modifierId)
    this.setStatus(`${modifierName || "Modifier group"} removed locally. Save the item to persist it.`, "success")
    return true
  }

  resetModifierDraftIfEditingMatch({
    modifierId = null,
    localModifierId = null,
    itemableId = null,
    itemableType = null,
  } = {}) {
    const editingGroup = {
      modifier_id: this.editingModifierCollectionId,
      local_modifier_id: this.editingModifierLocalId,
      itemable_id: this.editingModifierItemableId,
      itemable_type: this.editingModifierItemableType,
    }

    if (!this.assignedModifierGroupMatches(editingGroup, {
      modifierId,
      localModifierId,
      itemableId,
      itemableType,
    })) {
      return
    }

    this.clearCurrentModifierEditState()
    this.resetModifierDraft()
  }

  resetStatus() {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = ""
    this.statusTarget.classList.remove("is-error", "is-success")
  }

  setStatus(message, state) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = message
    this.statusTarget.classList.remove("is-error", "is-success")
    this.statusTarget.classList.add(state === "error" ? "is-error" : "is-success")
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }

  csrfToken() {
    const element = document.querySelector('meta[name="csrf-token"]')
    return element ? element.content : ""
  }






  // --- Stock Items tab (menu items built from several stock items) ---

  resetStockItemsState() {
    this.stockItems = []
    this.stockItemsModeActive = false
    this.clearStockItemSearch()
    this.renderStockItemRows()
  }

  setStockItemsMode(active) {
    this.stockItemsModeActive = active

    this.element.querySelectorAll("[data-multiple-stock-item-field]").forEach((el) => { el.hidden = !active })
    this.element.querySelectorAll("[data-single-stock-item-field]").forEach((el) => { el.hidden = active })
  }

  applyStockItems(stockItems = []) {
    const rows = Array.isArray(stockItems) ? stockItems : []

    this.setStockItemsMode(rows.length > 1)
    this.stockItems = this.stockItemsModeActive ? rows.map((row) => this.buildStockItemState(row)) : []
    this.renderStockItemRows()
  }

  async reloadStockItems(menuItemId, restaurantId) {
    try {
      const response = await fetch(
        `/restaurants/${restaurantId}/v2/menu_items/${menuItemId}/editor_data`,
        { headers: { "Accept": "application/json" } }
      )
      if (!response.ok) return

      const data = await response.json()
      this.applyStockItems(data.stock_items)
      this.captureFormSnapshot()
    } catch (error) {
      console.error(error)
    }
  }

  buildStockItemState(overrides = {}) {
    return {
      key: `stock-item-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      collection_id: overrides.collection_id || null,
      item_id: overrides.item_id || overrides.id || null,
      name: overrides.name || "",
      cost_price: String(overrides.cost_price ?? "0.00"),
      stock_control_enabled: !!overrides.stock_control_enabled,
      stock_warning_threshold: overrides.stock_warning_threshold ?? "",
    }
  }

  stockItemsPayload() {
    return this.stockItems.map((row) => ({
      collection_id: row.collection_id,
      item_id: row.item_id,
      name: row.name,
      cost_price: row.cost_price,
      stock_control_enabled: row.stock_control_enabled,
      stock_warning_threshold: row.stock_warning_threshold,
    }))
  }

  appendStockItems(formData) {
    formData.delete("stock_items_json")

    if (!this.stockItemsModeActive) return

    formData.append("stock_items_json", JSON.stringify(this.stockItemsPayload()))
  }

  stockItemCatalog() {
    const attachedIds = this.stockItems.map((row) => String(row.item_id))
    return (this.optionCatalog.items || []).filter((item) => !attachedIds.includes(String(item.id)))
  }

  filterStockItems() {
    if (!this.hasStockItemSearchInputTarget || !this.hasStockItemSuggestionsTarget) return

    const query = this.stockItemSearchInputTarget.value.trim().toLowerCase()
    const matches = this.stockItemCatalog()
      .filter((item) => query.length === 0 || String(item.name || "").toLowerCase().includes(query))

    if (matches.length === 0) {
      this.stockItemSuggestionsTarget.innerHTML = ""
      this.stockItemSuggestionsTarget.hidden = true
      return
    }

    this.stockItemSuggestionsTarget.innerHTML = matches.map((item) => `
      <button
        type="button"
        class="menu-v2-modifier-suggestion"
        data-action="click->menu-item-drawer#selectStockItemSuggestion"
        data-item-id="${this.escapeHtml(item.id)}"
      >
        <span class="menu-v2-modifier-suggestion-label">${this.escapeHtml(item.name)}</span>
      </button>
    `).join("")

    this.stockItemSuggestionsTarget.hidden = false
  }

  toggleStockItemList(event) {
    if (event) event.preventDefault()
    if (!this.hasStockItemSuggestionsTarget || !this.hasStockItemSearchInputTarget) return

    if (this.stockItemSuggestionsTarget.hidden) {
      this.filterStockItems()
      this.stockItemSearchInputTarget.focus()
    } else {
      this.stockItemSuggestionsTarget.hidden = true
    }
  }

  selectStockItemSuggestion(event) {
    event.preventDefault()

    const item = (this.optionCatalog.items || []).find((catalogItem) => (
      String(catalogItem.id) === String(event.currentTarget.dataset.itemId)
    ))
    if (!item) return

    this.stockItems.push(this.buildStockItemState(item))
    this.clearStockItemSearch()
    this.renderStockItemRows()
  }

  addNewStockItem(event) {
    if (event) event.preventDefault()

    const name = this.hasStockItemSearchInputTarget ? this.stockItemSearchInputTarget.value.trim() : ""
    if (!name) {
      this.setStatus("Type a name for the new stock item first.", "error")
      return
    }

    this.stockItems.push(this.buildStockItemState({ name }))
    this.clearStockItemSearch()
    this.renderStockItemRows()
  }

  removeStockItem(event) {
    event.preventDefault()

    if (this.stockItems.length <= 1) {
      this.setStatus("A menu item needs at least one stock item.", "error")
      return
    }

    const key = event.currentTarget.closest("[data-stock-item-key]")?.dataset.stockItemKey
    this.stockItems = this.stockItems.filter((row) => row.key !== key)
    this.renderStockItemRows()
  }

  syncStockItemRow(event) {
    const input = event.currentTarget
    const key = input.closest("[data-stock-item-key]")?.dataset.stockItemKey
    const field = input.dataset.field
    const row = this.stockItems.find((stockItem) => stockItem.key === key)
    if (!row || !field) return

    row[field] = input.type === "checkbox" ? input.checked : input.value
  }

  clearStockItemSearch() {
    if (this.hasStockItemSearchInputTarget) this.stockItemSearchInputTarget.value = ""
    if (this.hasStockItemSuggestionsTarget) {
      this.stockItemSuggestionsTarget.innerHTML = ""
      this.stockItemSuggestionsTarget.hidden = true
    }
  }

  renderStockItemRows() {
    if (!this.hasStockItemRowsTarget) return

    this.stockItemRowsTarget.innerHTML = this.stockItems.map((row) => this.stockItemRowMarkup(row)).join("")

    if (this.hasStockItemCountTarget) {
      const count = this.stockItems.length
      this.stockItemCountTarget.textContent = `${count} ${count === 1 ? "item" : "items"}`
    }
  }

  stockItemRowMarkup(row) {
    const showThreshold = this.stockItemRowsTarget.dataset.showThreshold === "true"

    return `
      <div class="menu-v2-stock-item-card" data-stock-item-key="${this.escapeHtml(row.key)}">
        <div class="menu-v2-stock-item-card-header">
          <input
            type="text"
            class="menu-v2-input"
            placeholder="Stock item name"
            aria-label="Stock item name"
            value="${this.escapeHtml(row.name)}"
            data-field="name"
            data-action="input->menu-item-drawer#syncStockItemRow"
          />
          <button type="button" class="remove-btn" data-action="click->menu-item-drawer#removeStockItem" aria-label="Remove stock item" title="Remove">
            &times;
          </button>
        </div>

        <div class="menu-v2-stock-item-fields${showThreshold ? "" : " is-compact"}">
          <label class="menu-v2-stock-item-field">
            <span class="menu-v2-stock-item-label">Cost Price</span>
            <span class="menu-v2-stock-item-money">
              <span class="menu-v2-stock-item-currency">£</span>
              <input
                type="number"
                step="0.01"
                min="0"
                value="${this.escapeHtml(row.cost_price)}"
                data-field="cost_price"
                data-action="input->menu-item-drawer#syncStockItemRow"
              />
            </span>
          </label>

          ${showThreshold ? `
          <label class="menu-v2-stock-item-field">
            <span class="menu-v2-stock-item-label">Warn Below</span>
            <input
              type="number"
              step="1"
              min="0"
              placeholder="Auto"
              value="${this.escapeHtml(row.stock_warning_threshold ?? "")}"
              data-field="stock_warning_threshold"
              data-action="input->menu-item-drawer#syncStockItemRow"
            />
          </label>` : ""}
        </div>

        <label class="menu-v2-stock-item-toggle">
          <span>Stock Control</span>
          <span class="switch">
            <input
              type="checkbox"
              ${row.stock_control_enabled ? "checked" : ""}
              data-field="stock_control_enabled"
              data-action="change->menu-item-drawer#syncStockItemRow"
            />
            <span class="slider"></span>
          </span>
        </label>
      </div>
    `
  }

  switchTab(event) {
    event.preventDefault()
    const tabId = event.currentTarget.dataset.tab
    this.setActiveTab(tabId)
  }

  setActiveTab(tabId) {
    const selectedTabId = String(tabId)

    this.panel2Targets.forEach(panel => {
      panel.hidden = panel.dataset.panel2 !== selectedTabId
    })

    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tab === selectedTabId
      tab.classList.toggle("active", isActive)
      tab.classList.toggle("is-active", isActive)
    })
  }

  async submitForm(event) {
    event.preventDefault()

    // Guard against accidental double-submits: ignore re-entry and disable the
    // Save button until the request finishes (re-enabled in the finally block).
    if (this.hasSaveButtonTarget) {
      if (this.saveButtonTarget.disabled) return
      this.saveButtonTarget.disabled = true
    }

    const form = this.formTarget
    const url = form.action
    const formData = new FormData(form)

    this.removeModifierDraftFields(formData)
    this.appendAssignedModifierGroups(formData)
    this.appendRemovedModifierCollectionIds(formData)
    this.appendStockItems(formData)

    const categoryId = formData.get("category_id")
    const shouldUsePut = categoryId === null || String(categoryId).trim() === ""
    const requestMethod = shouldUsePut ? "put" : "post"

    if (formData.has("_method")) {
      formData.set("_method", requestMethod)
    } else {
      formData.append("_method", requestMethod)
    }

    formData.set("menu_id", this.getMenuId());

    this.statusTarget.textContent = "Saving…"

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json"
        },
        body: formData
      })

      const data = await response.json()

      if (!response.ok) throw new Error(data.error || (data.errors || []).join(", ") || "Failed to save")

      if (data.markdown) {
        document.getElementById("menu-v2-category-counts").innerHTML = data.markdown
      }

      if (data.markdown_2) {
        document.getElementById("menu-v2-category-list").innerHTML = data.markdown_2
      }

      this.syncSavedMenuItem(data.menu_item)
      this.resetCropperModal()

      this.resetModifierDraftAfterSave()
      this.captureFormSnapshot()

      const savedMenuItemId = data.menu_item?.id || this.activeTrigger?.dataset.menuItemId
      const savedRestaurantId = this.activeTrigger?.dataset.restaurantId || this.restaurantIdFromUrl(url)

      if (shouldUsePut && savedMenuItemId && savedRestaurantId) {
        this.loadCurrentModifiers(savedMenuItemId, savedRestaurantId)
        // Pull fresh modifier values from the DB so re-opening a group shows
        // what was just saved instead of the stale, pre-save catalog.
        this.refreshDrawerPickerSources(savedRestaurantId)
        // New stock item rows now have ids; reload so a second save updates
        // them instead of creating them again.
        if (this.stockItemsModeActive) await this.reloadStockItems(savedMenuItemId, savedRestaurantId)
      }

      if (!shouldUsePut && data.id) {
        const restaurantId = this.activeTrigger?.dataset.restaurantId || this.restaurantIdFromUrl(url)
        const newId = data.id
        const categoryIdInput = this.formTarget.querySelector('[name="category_id"]')

        this.formTarget.action = `/restaurants/${restaurantId}/v2/menu_items/${newId}`
        this.formTarget.method = "PUT"

        if (categoryIdInput) {
          categoryIdInput.value = ""
        }

        if (this.activeTrigger) {
          this.activeTrigger.dataset.menuItemId = String(newId)
        }

        this.drawerTarget.classList.add("is-open")
        this.drawerTarget.setAttribute("aria-hidden", "false")

        this.loadMenuItem(newId, restaurantId)
        this.loadCurrentModifiers(newId, restaurantId)
        this.refreshDrawerPickerSources(restaurantId)
      }

      // Success
      this.statusTarget.textContent = "Saved!"
      this.notifyMenuChanged()

      this.titleTarget.textContent = "Edit Product"
      // optionally close drawer or update UI
      // this.drawerTarget.classList.remove("is-open")
      // this.drawerTarget.setAttribute("aria-hidden", "true")

    } catch (error) {
      console.error(error)
      this.statusTarget.textContent = `Error: ${error.message}`
    } finally {
      if (this.hasSaveButtonTarget) {
        this.saveButtonTarget.disabled = false
      }
    }
  }

  restaurantIdFromUrl(url) {
    const matches = String(url).match(/\/restaurants\/([^/]+)/)
    return matches ? matches[1] : null
  }

  removeModifierDraftFields(formData) {
    [
      "option_name",
      "required",
      "max_selection",
      "new_item_name[]",
      "new_item_max[]",
      "new_item_price[]",
    ].forEach((fieldName) => formData.delete(fieldName))
  }

  appendAssignedModifierGroups(formData) {
    formData.delete("assigned_modifiers_json")

    if (this.assignedModifierGroups.length === 0) return

    formData.append("assigned_modifiers_json", JSON.stringify(this.assignedModifierGroups))
  }

  appendRemovedModifierCollectionIds(formData) {
    formData.delete("removed_modifier_collection_ids_json")

    if (this.removedModifierCollectionIds.length === 0) return

    formData.append("removed_modifier_collection_ids_json", JSON.stringify(this.removedModifierCollectionIds))
  }

  resetCropperModal() {
    const cropperModal = this.formTarget.querySelector("#imageCropperModal")
    if (!cropperModal) return

    cropperModal.dispatchEvent(new CustomEvent("menu-item-drawer:image-saved", { bubbles: true }))
  }

  getMenuId() {
    const parts = window.location.pathname.split("/");
    const menuId = parts[5];

    return menuId
  }

  // Tells the save bar this menu now differs from its published copy. Fired on
  // document because the bar lives outside this controller's element.
  notifyMenuChanged() {
    document.dispatchEvent(new CustomEvent("menu-v2:changed"))
  }
}
